import { useRouter, type Router } from 'vue-router'

import { removeAuthTokens } from 'src/utils/authTokens'
import { toast } from 'src/utils/toast'
import { translate } from 'src/utils/translation'
import { StorageService } from 'src/services/storage'

export const useRequestHandler = (_router: Router | null = null) => {
  const handleRequestError = async (
    status: number,
    message: string,
    pageLang: any,
  ) => {
    const router: Router = _router || useRouter()
    await _router?.isReady()

    if (status === 401) {
      removeAuthTokens()
      router.push({ name: 'Login' })
      toast.error({
        toastMessage: translate('messages.login_required', pageLang),
      })
    } else if (status >= 500) {
      toast.error({
        toastMessage: translate('messages.error_occurred', pageLang),
      })
    } else {
      if (message) {
        toast.error({
          toastMessage: message,
        })
      } else {
        toast.error({
          toastMessage: translate('messages.error_occurred', pageLang.value),
        })
      }
    }
  }

  return {
    handleRequestError,
  }
}

export function debounceSearch(
  callback: (value: any) => void,
  delay = 300,
  minLength = 3,
) {
  let timer: ReturnType<typeof setTimeout>

  return function (value: any) {
    if (value.search.length < minLength) {
      return
    }

    clearTimeout(timer)
    timer = setTimeout(() => {
      callback(value)
    }, delay)
  }
}

export const onImageUpload: any = async (
  event: any,
  pageLang: string,
  callback: CallableFunction,
) => {
  const { handleRequestError } = useRequestHandler()
  const formData = new FormData()
  formData.append('image', (event.target || event.dataTransfer).files[0])

  const { isSuccess, message, data, status } =
    await StorageService.upload(formData)

  if (isSuccess) {
    callback(data)
    event.target.value = null
    toast.success({
      toastMessage: translate('messages.upload_image_success', pageLang),
    })
  } else {
    handleRequestError(status, message, pageLang)
  }
}

export const clearTimers = (intervalId: null | number) => {
  if (intervalId) clearInterval(intervalId)
}
